import { z } from 'zod';

const StatusInfoSchema = z.object({
  family: z.string(),
  statusCode: z.number(),
  reasonPhrase: z.string(),
});

export const PaymentResponseSchema = z.object({
  status: z.number().nullish(),
  entity: z.unknown().nullable(),
  entityAnnotations: z.unknown().nullable(),
  metadata: z.record(z.unknown()).nullish(),
  outMessage: z.string().nullish(),
  cookies: z.record(z.unknown()).nullish(),
  length: z.number().nullish(),
  language: z.string().nullish(),
  location: z.string().nullish(),
  lastModified: z.string().nullish(),
  date: z.string().nullable(),
  headers: z.record(z.unknown()),
  mediaType: z.string().nullable(),
  allowedMethods: z.array(z.string()),
  statusInfo: StatusInfoSchema,
  entityTag: z.string().nullable(),
  links: z.array(z.string()),
  stringHeaders: z.record(z.string()),
  actualEntity: z.unknown().nullable(),
});

export type PaymentResponse = z.infer<typeof PaymentResponseSchema>;
